import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { ITransactionResponse } from '../models/transactions.model';

export const transactionsAllFeatureKey = 'transactionsAll';

export interface TransactionsAllState {
  loadTransactionsAll: any;
  loadTransactionsAllSuccess: ITransactionResponse[];
  loadTransactionsAllFailure: any;
}

export const initialState: TransactionsAllState = {
  loadTransactionsAll: undefined,
  loadTransactionsAllSuccess: undefined,
  loadTransactionsAllFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadTransactionsSuccess, (state, action) => ({
    ...state,
    loadTransactionsAllSuccess: action.response
  })),
  on(actions.loadTransactionsFailure, (state, action) => ({
    ...state,
    loadTransactionsAllFailure: action.error
  }))
);

export const getTransactionsAll = (state: TransactionsAllState) => state.loadTransactionsAllSuccess;
